import { Store, HeartPulse, Building2, ShoppingBag, Sparkles, MapPin } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const ICONS = [Store, HeartPulse, Building2, ShoppingBag, Sparkles, MapPin];

export default function Sectors({ sectors }) {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="sektorler" className="py-24 md:py-32" data-testid="sectors-section">
      <div ref={ref} className={`reveal mx-auto max-w-7xl px-6 md:px-12 ${isVisible ? "is-visible" : ""}`}>
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Referanslarımız</p>
          <h2 className="mt-3 text-2xl font-normal tracking-tight text-white sm:text-3xl lg:text-4xl">
            Çalıştığımız sektörler
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-400">
            Türkiye'nin her yerinden farklı sektörlerdeki işletmelere Meta reklam ajansı hizmeti sunuyoruz.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {sectors.map((sector, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={sector.title}
                className="group rounded-2xl border border-white/5 bg-white/[0.02] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-gold/30"
                style={{ transitionDelay: isVisible ? `${i * 80}ms` : "0ms" }}
                data-testid={`sector-card-${i}`}
              >
                <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg border border-gold/20 bg-gold/[0.06]">
                  <Icon className="h-5 w-5 text-gold-light" />
                </div>
                <h3 className="text-lg font-medium text-white">{sector.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{sector.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
